
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../../components/LanguageSwitcher';

export default function Header() {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { label: t('nav.home'), href: '/' },
    { label: t('nav.services'), href: '#services' },
    { label: t('nav.about'), href: '#about' },
    { label: t('nav.process'), href: '#process' },
    { label: t('nav.whyUs'), href: '#why-us' },
    { label: t('nav.portfolio'), href: '#portfolio' },
    { label: t('nav.testimonials'), href: '#testimonials' },
    { label: 'Blog', href: '/blog' },
    { label: t('nav.careers'), href: '/careers' },
  ];

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const handleNavigation = (e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    
    // Blog veya Careers sayfasına gidiyorsa, direkt navigate et
    if (target === '/blog' || target === '/careers') {
      window.REACT_APP_NAVIGATE(target);
      setIsMenuOpen(false);
      return;
    }
    
    // Blog sayfasındaysak, önce ana sayfaya git
    if (window.location.pathname.includes('/blog') || window.location.pathname.includes('/careers')) {
      window.REACT_APP_NAVIGATE('/');
      setTimeout(() => {
        const element = document.querySelector(target);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.querySelector(target);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleLogoClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.REACT_APP_NAVIGATE('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
      <nav className="mx-auto px-6 lg:px-12 py-4">
        <div className="flex items-center justify-between">
          <a 
            href="/" 
            onClick={handleLogoClick}
            className="flex items-center gap-2 cursor-pointer"
          >
            <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center">
              <i className="ri-sparkling-2-fill text-white text-xl"></i>
            </div>
            <span className="text-2xl font-bold text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
              Roba Temizlik
            </span>
          </a>

          <div className="hidden lg:flex items-center gap-8">
            <a 
              href="/" 
              className="text-gray-700 hover:text-teal-600 font-medium transition-colors cursor-pointer"
              onClick={(e) => handleNavigation(e, '/')}
            >
              {t('nav.home')}
            </a>
            <a 
              href="#services" 
              className="text-gray-700 hover:text-teal-600 font-medium transition-colors cursor-pointer"
              onClick={(e) => handleNavigation(e, '#services')}
            >
              {t('nav.services')}
            </a>
            <a 
              href="#portfolio" 
              className="text-gray-700 hover:text-teal-600 font-medium transition-colors cursor-pointer"
              onClick={(e) => handleNavigation(e, '#portfolio')}
            >
              {t('nav.portfolio')}
            </a>
            <a 
              href="/blog" 
              className="text-gray-700 hover:text-teal-600 font-medium transition-colors cursor-pointer"
              onClick={(e) => handleNavigation(e, '/blog')}
            >
              Blog
            </a>
            <a 
              href="/careers" 
              className="text-gray-700 hover:text-teal-600 font-medium transition-colors cursor-pointer"
              onClick={(e) => handleNavigation(e, '/careers')}
            >
              {t('nav.careers')}
            </a>
            <a 
              href="#contact" 
              className="text-gray-700 hover:text-teal-600 font-medium transition-colors cursor-pointer"
              onClick={(e) => handleNavigation(e, '#contact')}
            >
              {t('nav.contact')}
            </a>
            <LanguageSwitcher />
            <a
              href="#contact"
              className="bg-teal-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-teal-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                handleNavigation(e, '#contact');
              }}
            >
              {t('Teklif Al')}
            </a>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-gray-700 text-2xl w-10 h-10 flex items-center justify-center cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-100 pt-4">
            <div className="px-4 pt-2 pb-4 space-y-2">
              <a 
                href="/" 
                className="block px-4 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 rounded-lg transition-colors cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  setIsMenuOpen(false);
                  window.REACT_APP_NAVIGATE('/');
                }}
              >
                {t('nav.home')}
              </a>
              <a 
                href="#services" 
                className="block px-4 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 rounded-lg transition-colors cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  setIsMenuOpen(false);
                  handleNavigation(e, '#services');
                }}
              >
                {t('nav.services')}
              </a>
              <a 
                href="#about" 
                className="block px-4 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 rounded-lg transition-colors cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  setIsMenuOpen(false);
                  handleNavigation(e, '#about');
                }}
              >
                {t('nav.about')}
              </a>
              <a 
                href="#portfolio" 
                className="block px-4 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 rounded-lg transition-colors cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  setIsMenuOpen(false);
                  handleNavigation(e, '#portfolio');
                }}
              >
                {t('nav.portfolio')}
              </a>
              <a 
                href="/blog" 
                className="block px-4 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 rounded-lg transition-colors cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  setIsMenuOpen(false);
                  window.REACT_APP_NAVIGATE('/blog');
                }}
              >
                Blog
              </a>
              <a 
                href="/careers" 
                className="block px-4 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 rounded-lg transition-colors cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  setIsMenuOpen(false);
                  window.REACT_APP_NAVIGATE('/careers');
                }}
              >
                {t('nav.careers')}
              </a>
              <a 
                href="#contact" 
                className="block px-4 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 rounded-lg transition-colors cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  setIsMenuOpen(false);
                  handleNavigation(e, '#contact');
                }}
              >
                {t('nav.contact')}
              </a>
              <div className="px-4 py-2">
                <LanguageSwitcher />
              </div>
              <a
                href="#contact"
                className="block mx-4 mt-2 bg-teal-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-teal-700 transition-all shadow-lg text-center whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  setIsMenuOpen(false);
                  handleNavigation(e, '#contact');
                }}
              >
                {t('Teklif Al')}
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
